const asyncLibrary = (fetchUrl) => {
    let promise = null;
    return () => {
        if (promise) return promise;
        promise = fetch(fetchUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json();
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
                throw error;
            });
        return promise;
    };
};//https://dy-static.oss-cn-beijing.aliyuncs.com/project_json_index/backdrops.json
export const getBackdropLibrary = asyncLibrary('https://dy-static.oss-cn-beijing.aliyuncs.com/project_json_index/backdrops.json');
export const getCostumeLibrary = asyncLibrary('https://dy-static.oss-cn-beijing.aliyuncs.com/project_json_index/costumes.json');
export const getSoundLibrary = asyncLibrary('https://dy-static.oss-cn-beijing.aliyuncs.com/project_json_index/sounds.json');
export const getSpriteLibrary = asyncLibrary('https://dy-static.oss-cn-beijing.aliyuncs.com/project_json_index/sprites.json');
